var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '../../@patternfly/patternfly-next/layouts/Toolbar/toolbar.css.js';
import PropTypes from 'prop-types';

var propTypes = {
  /** Anything that can be rendered as toolbar section */
  children: PropTypes.node,
  /** Classes applied to toolbar section */
  className: PropTypes.string,
  /** Aria label applied to toolbar section */
  'aria-label': function ariaLabel(props) {
    if (!props['aria-label']) {
      return new Error('ToolbarSection requires aria-label to be specified');
    }
    return null;
  }
};

var defaultProps = {
  children: null,
  className: null,
  'aria-label': null
};

var ToolbarSection = function ToolbarSection(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ['children', 'className']);

  return React.createElement(
    'section',
    _extends({}, props, { className: css(styles.toolbarSection, className) }),
    children
  );
};

ToolbarSection.propTypes = propTypes;
ToolbarSection.defaultProps = defaultProps;

export default ToolbarSection;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-core/dist/esm/layouts/Toolbar/ToolbarSection.js
// module id = 313
// module chunks = 0